import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import { NavigationBar } from "../components/NavigationBar";
import '../../styles/mainpage.css';
import HelperService from "../Services/Bll/HelperService";
import { FilterPanel } from "../components/FilterPanelComponent";
import { BarChartCustom } from "../components/charts/BarChartCustom"
import { BasicIndicator } from "../components/charts/BasicIndicator"
import FilterPanelProvider from "../Provider/FilterPanelProvider";
import { ViewContext } from "../Context/ViewContext"
import KpiService from "../Services/Bll/KpiService";
import {createTheme, useMediaQuery} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import LoaderComponent from "../components/LoaderComponent";

export default function MargePage() {
    const {loader, showLoader, hideLoader} = useContext(ViewContext);
    const kpiService = new KpiService();

    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
    });
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    useEffect(() => {
        const fetchParams = {navigate, logged, showLoader, hideLoader, setKpi, isMobile};
        kpiService.fetchData(fetchParams)
    }, [])

    const [kpi, setKpi] = useState(null);
    const navigate = useNavigate()
    const logged = HelperService.isLogged()
    const [loadingPage, setLoadingPage] = useState(null);

    const handleKpiUpdate = (newsKpi) => {
        kpiService.handleKpiUpdate(newsKpi, setKpi)
    };

    const handleLoadingPage = (loading) => {
        setLoadingPage(loading);
    }

    const labels = {label: kpi?.label, labelSecond: kpi?.labelSecond};

    const columns = [
        { field: 'result', headerName: 'Résultat(s)', flex: 1 },
        { field: 'value2024', headerName: '2024', flex: 1 },
        { field: 'total2024', headerName: 'Total (%)', flex: 1 },
        { field: 'value2023', headerName: '2023', flex: 1 },
        { field: 'total2023', headerName: 'Total (%) 2023', flex: 1 },
        { field: 'difference', headerName: 'Écart', flex: 1,  renderCell: (params) => (
                <span style={{ color: params.value < 0 ? 'red' : 'green' }}>
        {params.value}
      </span>
            ), },
        { field: 'percentDifference', headerName: '%', flex: 1,  renderCell: (params) => (
                <span style={{ color: params.value.includes('-') ? 'red' : 'green' }}>
        {params.value}
      </span>
            ), },
    ];

    if (loader) return null;

    return (
        <>
            <NavigationBar/>
            <FilterPanelProvider>
                {isMobile ? (
                    <Accordion className="h-auto" sx={{backgroundColor:'#b57ee3', borderRadius: '0 !important'}}>
                        <AccordionSummary
                            sx={{color:'white'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            <span style={{fontSize:'12px', fontWeight:'bold'}}>Filtre</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FilterPanel onKpiUpdate={handleKpiUpdate} isMobile={isMobile} onLoadingPage={handleLoadingPage}/>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <FilterPanel onKpiUpdate={handleKpiUpdate} onLoadingPage={handleLoadingPage}/>
                )}
            </FilterPanelProvider>
            <LoaderComponent loadingPage={loadingPage}/>
            {!loadingPage && (
                <div className={`indicContainer ${isMobile ? 'container' : ''}`}>
                    <BasicIndicator data={kpi?.currentMarge} dataBis={kpi?.currentMargeSecond} />
                    <BasicIndicator data={kpi?.objectiveMarge} dataBis={kpi?.objectiveMargeSecond} />
                    <BasicIndicator data={kpi?.currentVsPreviousYearMarge} dataBis={kpi?.currentVsPreviousYearMargeSecond} />
                    <BasicIndicator data={kpi?.currentComm} dataBis={kpi?.currentCommSecond} />

                    {kpi?.histo1 && <BarChartCustom data={kpi?.histo1} dataBis={kpi?.histo1Second}
                                                    title="Taux de commissions par mois de départ" groupMode="grouped"
                                                    layout="vertical" keysArray={['N', 'N-1', 'objectif']} width="40.5%"
                                                    colors={"pastel2"} left="100" isPercentage={true} labels={labels}/>}
                    {kpi?.histo2 && <BarChartCustom data={kpi?.histo2} dataBis={kpi?.histo2Second}
                                                    title="Taux de marge par mois de départ" groupMode="grouped"
                                                    layout="vertical" keysArray={['N', 'N-1', 'objectif']} width="40.5%"
                                                    isPercentage={true} left="100" labels={labels}/>}


                    {kpi?.histo3 &&
                        <BarChartCustom data={kpi?.histo3} dataBis={kpi?.histo3Second} title="Taux de marge par destination"
                                        groupMode="grouped" layout="vertical" keysArray={['N', 'N-1', 'objectif']}
                                        width="82%" isPercentage={true} fontSizeX={"8px"} labels={labels}/>}
                    {kpi?.histo6 && <BarChartCustom data={kpi?.histo6} dataBis={kpi?.histo6Second}
                                                    title="Taux de marge mois par agent de réservation"
                                                    groupMode="grouped" layout="vertical"
                                                    keysArray={['N', 'N-1', 'objectif']} width="82%" isPercentage={true}
                                                    fontSizeX={"8px"} labels={labels}/>}
                    {kpi?.histo4 &&
                        <BarChartCustom data={kpi?.histo4} dataBis={kpi?.histo4Second} title="Taux de marge Réseaux"
                                        groupMode="grouped" layout="vertical" keysArray={['N', 'N-1', 'objectif']}
                                        width="40%" isPercentage={true} fontSizeX={"8px"} labels={labels}/>}

                    {kpi?.histo5 &&
                        <BarChartCustom data={kpi?.histo5} dataBis={kpi?.histo5Second} title="Taux de marge par commerciaux"
                                        groupMode="grouped" layout="vertical" keysArray={['N', 'N-1', 'objectif']}
                                        width="40%" isPercentage={true}  left="100" fontSize={"8px"} labels={labels}/>}

                </div>)}
        </>
    );
}
